import { useAuthStore } from '~/store/auth.store';

/** Internal staff — the only users shown the retailer picker. */
const INTERNAL_EMAIL_DOMAIN = '@lily.ai';

/**
 * Whether the current user may pick a google-agent retailer prompt.
 * Only `@lily.ai` users test retailer prompts; everyone else never sees the control and sends
 * no retailer, so the agent uses its shared prompt.
 */
export function useCanChooseRetailerPrompt(): boolean {
  const email = useAuthStore((s) => s.user?.email ?? '');
  return email.toLowerCase().endsWith(INTERNAL_EMAIL_DOMAIN);
}
